import LonghairImage from '../../images/games/35gender/longhair.png';
import CryingImage from '../../images/games/35gender/crying.png';
import PunchingImage from '../../images/games/35gender/punching.png';
import FlowerImage from '../../images/games/35gender/flowers.png';
import RemotecontrolcarsImage from '../../images/games/35gender/remotecontrolcars';

import CookImage from '../../images/games/35gender/cook.png';
import PilotImgae from '../../images/games/35gender/pilot.png';
import NurseImage from '../../images/games/35gender/nurse.png';
import FirefighterImage from '../../images/games/35gender/firefighter.png'
import MechanicImage from '../../images/games/35gender/mechanic.png';

import FootballplayerImage from '../../images/games/35gender/footballplayer.png';
import BasketballplayerImage from '../../images/games/35gender/basketballplayer.png';
import SwimmerImage from '../../images/games/35gender/swimmer.png';
import GymnastImage from '../../images/games/35gender/gymnast.png';
import RacecardriverImage from '../../images/games/35gender/racecardriver.png';

import ComicbookImage from '../../images/games/35gender/comicbook.png';
import BaseballgloveImage from '../../images/games/35gender/baseballglove.png';
import StuffedanimalsImage from '../../images/games/35gender/stuffedanimals.png';
import CarsImage from '../../images/games/35gender/cars.png';
import JewelryImage from '../../images/games/35gender/jewelry.png';

import CountryImage from '../../images/games/35gender/country.png';
import RapImage from '../../images/games/35gender/rap.png';
import PopImage from '../../images/games/35gender/pop.png';
import RockandrollImage from '../../images/games/35gender/rockandroll.png';
import MarchingbandImage from '../../images/games/35gender/marchingband.png';

import EggpdImage from '../../images/games/35gender/eggpd.png';
import CatpdImage from '../../images/games/35gender/catpd.png';
import EggstrImage from '../../images/games/35gender/eggstr.png';
import CatstrImage from '../../images/games/35gender/catstr.png';
import EggsprImage from '../../images/games/35gender/eggspr.png';
import CatsprImage from '../../images/games/35gender/catspr.png';
import EggImage from '../../images/games/35gender/egg.png';
import CatImage from '../../images/games/35gender/cat.png';

var question = ["longhair", "crying", "punching", "flowers", "remotecontrolcars"];
var descr = ["Long Hair","Crying","Punching","Flowers","Remote Control Cars"];
var biasFull = ["girl","girl","boy","girl","boy"];
var biasNone = ["both","both","both","both","both"];
var topic = ["this","job","job","thing","music"]
var set = [];
var active = 1;
var fiveQ = 0;
var result = "Discussion";

var image_path_array = [LonghairImage, CryingImage, PunchingImage, FlowerImage, RemotecontrolcarsImage];

function changeDesc(x) {
	$("#desc").text("Who does this " + x + " belong to?");
};

function questions() {
	set = [];
	active = 1;
	changeDesc(topic[fiveQ])
	if(fiveQ == 1) {
		question = ["cook","pilot","nurse","firefighter", "mechanic"];
		biasFull = ["girl","boy","girl","boy","boy"];
		descr = ["Cook","Pilot","Nurse","Firefighter","Mechanic"];

		image_path_array = [CookImage, PilotImgae, NurseImage, FirefighterImage, MechanicImage];

		$("#resDesc").text(I18n.t('game_questions.gender_game.grow_up_wish'));
		$("#resDescTwo").text(I18n.t('game_questions.gender_game.jobs_for_girls_or_boys'));
		$("#resDescThr").text("");
	} else if(fiveQ == 2) {
		question = ["footballplayer","basketballplayer","swimmer","gymnast","racecardriver"];
		biasFull = ["boy","boy","both","girl","boy"];
		descr = ["Football Player","Basketball Player","Swimmer","Gymnast","Race Car Driver"];

		image_path_array = [FootballplayerImage, BasketballplayerImage, SwimmerImage, GymnastImage, RacecardriverImage];

		$(".qimg").show();
		$("#resDescTwo").removeClass("padding");
		$("#resDescThr").removeClass("padding");
		$("#resDesc").text(I18n.t('game_questions.gender_game.pictures_question'));
		$("#resDescTwo").text("");
		$("#resDescThr").text("");
	} else if(fiveQ == 3) {
		question = ["comicbook","baseballglove","stuffedanimals","cars","jewelry"];
		biasFull = ["boy","boy","girl","boy","girl"];
		descr = ["Comic Book","Baseball Glove","Stuffed Animals","Cars","Jewelry"];

		image_path_array = [ComicbookImage, BaseballgloveImage, StuffedanimalsImage, CarsImage, JewelryImage];

		$(".qimg").hide();
		$("#resDesc").text(I18n.t('game_questions.gender_game.gift_question'));
		$("#resDescTwo").text(I18n.t('game_questions.gender_game.video_game_question'));
	} else if(fiveQ == 4) {
		question = ["country","rap","pop","rockandroll","marchingband"];
		biasFull = ["girl","boy","girl","boy","both"];
		descr = ["Country","Rap","Pop","Rock and Roll","Marching Band"];

		image_path_array = [CountryImage, RapImage, PopImage, RockandrollImage, MarchingbandImage];

		$("#resDesc").text(I18n.t('game_questions.gender_game.country_singer'));
		$("#resDescTwo").text(I18n.t('game_questions.gender_game.rapper'));
		$("#resDescThr").text(I18n.t('game_questions.gender_game.pop_artist'));
		$("#resDescFour").text(I18n.t('game_questions.gender_game.rock_and_roll_band'));
		$("#resDescFive").text(I18n.t('game_questions.gender_game.people_marching'));
	} else {
		question = ["longhair", "crying", "punching", "flowers", "remotecontrolcars"];
		image_path_array = [LonghairImage, CryingImage, PunchingImage, FlowerImage, RemotecontrolcarsImage]
	}
	$("#picDiv img").attr("src", image_path_array[0]);
	$("#picDesc").text(descr[0]);
};

function nextImg() {
	$("#picDiv img").attr("src", image_path_array[active]);
	$("#picDesc").text(descr[active]);
	if(set.length == 5) {
		$("#mainGame").hide();
		$("#resMain").show();
		$(".avaChange").show();
		if (fiveQ < 3) {
			$("#egg").addClass("wiggle");
		} else if(fiveQ == 3) {
			$("#egg").addClass("wiggleFast");
		} else {
			$("#egg").removeClass("wiggleFast");
			$("#egg").removeClass("wiggle");
		}
		$(".avaChange").show();
		if(fiveQ == 1) {
			$("#resDescTwo").hide();
			$("#resDescThr").hide();
			$("#change1").text("Dot");
			$("#change2").text("Stripe");
			$("#change3").text("Spiral");
			$('p#avaDesc').text('Choose One');
		} else if(fiveQ == 2) {
			$("#discNext").hide();
			$("#next").show();
			$("#change1").text("Small");
			$("#change2").text("Medium");
			$("#change3").text("Large");
			$('p#avaDesc').text('Choose One');
		} else if(fiveQ == 3) {
			$(".avaChange").hide();
			$("#avaClose").show();
			$("#name").show();
			$("#discNext").hide();
		} else if(fiveQ == 4) {
			$("#discNext").hide();
			$("#name").hide();
			$(".avaChange").hide();
			$("#avaClose").text(I18n.t('game_questions.gender_game.click_next'))
			$("#avaClose").show();
		} else {
			$('p#avaDesc').text('Choose One');
			$(".avaChange").show();
				$("#resDesc").show();
				$("#resDescTwo").hide();
				$("#resDescThr").hide();
		}

		$("#d").text(result);
		fiveQ++;
	}
	active++;
};

jQuery(function() {
  $('.gender-35').on('click', "#dirPlay", function() {
    $("#mainDir").hide();
    $("#mainGame").show();
    $("#avaUI").show();
  })

  $('.gender-35').on('click', ".genBtn", function() {
    var choice = $(this).attr('id');
    set.push(choice);
  //	$("#c").text(active);
  //	$("#b").text(set);
  //	$("#a").text(biasNone);
    nextImg();
    $("#active").text(active);
    if (fiveQ == 3) {
      $("#change4").hide();
    }
  });

  $('.gender-35').on('click', "#discNext", function() {
    if(fiveQ == 1 || fiveQ == 2) {
      if($("#resDesc").is(':visible')) {
        $("#resDesc").hide();
        $("#resDescTwo").show();
        $("#discNext").hide();
        $("#next").show();
      } else if($("#resDescTwo").is(':visible')) {
        $("#resDescTwo").hide();
        $("#resDescThr").show();
        $("#discNext").hide();
        $("#next").show();
      }
    }
  });

  $('.gender-35').on('click', "#next", function() {
    $("#resMain").hide();
    $("#mainGame").show();
    $(".resDesc").show();
    $("#discNext").show();
    $("#picDesc").text(descr[active]);
    questions();
    $("#active").text(active);
    $(".avaChange").hide();
    $("#egg").removeClass("wiggle");
    $("#egg").removeClass("wiggleFast");
    if(fiveQ >= 5){
      $("#nameDisplay").text($("#name").val().replace("input=",''));
      $("#avaUI").hide();
      $("#egg").hide();
      $("#mainGame").hide();
      $("#fin").fadeIn();
      $("#eggCenter").fadeIn();
    }
    if(fiveQ == 1 || fiveQ == 2) {
      $("#next").hide();
    }
  });

  $('.gender-35').on('click', ".avaChange", function() {
    $('p#avaDesc').text('Answer questions and watch it change!');
    if(fiveQ == 1) {
      if($(this).text() == "Red") {
        $(".egg").css("background","crimson");
      } else if($(this).text() == "Green") {
        $(".egg").css("background", "#33df47");
      } else if ($(this).text() == "Yellow"){
        $(".egg").css("background", "#f3f43c");
      } else {
        $(".egg").css("background", "#fff")
      }
    } else if(fiveQ == 2) {
      if($(this).text() == "Dot") {
        $("#egg").attr("src", EggpdImage);
        $("#eggDone").attr("src", CatpdImage);
        $(".egg").addClass("dot");
      } else if($(this).text() == "Stripe") {
        $("#egg").attr("src", EggstrImage);
        $("#eggDone").attr("src", CatstrImage);
        $(".egg").addClass("stripe");
      } else if($(this).text() == "Spiral") {
        $("#egg").attr("src", EggsprImage);
        $("#eggDone").attr("src", CatsprImage);
        $(".egg").addClass("spiral");
      } else {
        $("#egg").attr("src", EggImage);
        $("#eggDone").attr("src", CatImage);
        $(".egg").removeClass("dot");
        $(".egg").removeClass("stripe");
        $(".egg").removeClass("spiral");
      }	} else if(fiveQ == 3) {
      if($(this).text() == "Small") {
        $(".egg").css("height", "150px");
        $(".egg").css("width", "150px");
        $(".eggDone").css("height", "150px");
        $(".eggDone").css("width", "150px");
      } else if($(this).text() == "Medium") {
        $(".egg").css("height", "200px");
        $(".egg").css("width", "200px");
        $(".eggDone").css("height", "200px");
        $(".eggDone").css("width", "200px");
      } else {
        $(".egg").css("height", "250px");
        $(".egg").css("width", "250px");
        $(".eggDone").css("height", "250px");
        $(".eggDone").css("width", "250px");
      }
    } else {
      $(".egg").css("background-color", "white");
    }
  })
})
